var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRShop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 28 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "magnifying-glass"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "search"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "btn-secondary",
    serifid: "btn secondary"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "ph-desktop"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "ph-note-pencil"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "ph-pen-nib"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-5",
    serifid: "Rating 5"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-4-5",
    serifid: "Rating 4,5"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-4",
    serifid: "Rating 4"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-3-5",
    serifid: "Rating 3,5"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-3",
    serifid: "Rating 3"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-2-5",
    serifid: "Rating 2,5"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-2",
    serifid: "Rating 2"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-1-5",
    serifid: "Rating 1,5"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-1",
    serifid: "Rating 1"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "magnifying-glass1",
    serifid: "magnifying-glass"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "file"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "file-earmark"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "file1",
    serifid: "file"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "boxes-stacked"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "chat-left-text"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "magnifying-glass2",
    serifid: "magnifying-glass"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "iconR-shop",
    x: 0,
    y: 0,
    width: 28,
    height: 24,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.169,12.557c-0,-0.355 -0.3,-0.646 -0.669,-0.646c-0.37,-0 -0.67,0.291 -0.67,0.646l0,6.126c0,1.278 1.075,2.317 2.401,2.317c-0,0 11.539,0 11.539,0c1.324,0 2.4,-1.039 2.4,-2.317l0,-6.126c0,-0.355 -0.301,-0.646 -0.669,-0.646c-0.368,-0 -0.669,0.291 -0.669,0.646l-0,2.695c-0,0 -13.663,0 -13.663,0c-0,0 -0,-2.695 -0,-2.695Zm-0,6.126l-0,-2.138c-0,-0 13.663,-0 13.663,-0c-0,-0 -0,2.138 -0,2.138c-0,0.567 -0.475,1.025 -1.062,1.025l-11.539,-0c-0.588,-0 -1.062,-0.458 -1.062,-1.025Zm11.944,-8.324c0.539,0.384 1.207,0.616 1.934,0.616c0.155,0 0.303,-0.01 0.448,-0.028c0,-0 0,-0 0,-0c2.068,-0.266 3.051,-2.606 1.945,-4.292c-0,-0 -2.066,-3.156 -2.066,-3.156c-0.201,-0.31 -0.559,-0.499 -0.94,-0.499l-12.867,0c-0.383,0 -0.741,0.189 -0.941,0.499l-2.068,3.156c-1.102,1.683 -0.123,4.026 1.938,4.292l0.449,0.028c0.695,0 1.392,-0.228 1.927,-0.639c0.15,-0.082 0.294,-0.198 0.425,-0.328c0.129,0.131 0.272,0.247 0.425,0.331l-0.003,-0.002c0.538,0.41 1.204,0.638 1.927,0.638c0.726,0 1.39,-0.228 1.928,-0.639c0.15,-0.082 0.292,-0.199 0.423,-0.329c0.131,0.131 0.274,0.248 0.427,0.332l-0.003,-0.002c0.538,0.41 1.201,0.638 1.927,0.638c0.731,0 1.403,-0.233 1.941,-0.62c0.147,-0.105 0.284,-0.221 0.41,-0.347c0.126,0.129 0.264,0.245 0.414,0.351l0,0Zm1.198,-6.067l1.999,3.053c0.636,0.972 0.017,2.189 -0.986,2.321c-0.094,0.01 -0.184,-0.014 -0.277,-0.014c-0.595,-0 -1.074,-0.208 -1.429,-0.584c-0.233,-0.251 -0.572,-0.394 -0.922,-0.394c-0.351,-0 -0.686,0.146 -0.923,0.398c-0.351,0.372 -0.854,0.58 -1.425,0.58c-0.571,-0 -1.077,-0.208 -1.428,-0.58c-0.234,-0.252 -0.604,-0.398 -0.923,-0.398c-0.35,-0 -0.688,0.146 -0.922,0.396c-0.382,0.373 -0.857,0.613 -1.429,0.613c-0.568,0 -1.074,-0.239 -1.425,-0.611c-0.238,-0.252 -0.573,-0.398 -0.923,-0.398c-0.354,-0 -0.689,0.146 -0.926,0.398c-0.352,0.372 -0.885,0.611 -1.427,0.611c-0.088,0 -0.181,-0.007 -0.274,-0.017c-0.998,-0.132 -1.616,-1.349 -0.981,-2.321c-0,-0 2,-3.053 2,-3.053l12.621,0Z",
    style: {
      fillRule: "nonzero"
    }
  }), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "pin-map"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRShop);
export default __webpack_public_path__ + "static/media/iconR-shop.b29d76accc4ae9de581e72b1a8559487.svg";
export { ForwardRef as ReactComponent };